
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_CONTRACTORS from "@/apollo/autocomplete-queries/GetContractors.gql";
  import GET_CONTRACTORS_WITH_PRIVATE_DATA from "@/apollo/autocomplete-queries/GetContractorsWithPrivateData.gql";

  import DropdownOption from "@/entities/DropdownOption";
  import { Contractor, Query_RootContractorArgs, User } from "@/generated/graphql";
  import getMultiselectEmployees from "@/helpers/getMultiselectEmployees";
  import EmployeeMultiselect from "@/components/autocompleteMultiselects/EmployeeMultiselect.vue";
  import EmployeeDropdownOption from "@/entities/EmployeeDropdownOption";
  import getUserFullData from "@/helpers/getUserFullData";

  @Component({
    components: {
      EmployeeMultiselect,
    },
    apollo: {
      contractorsPublic: {
        query: GET_CONTRACTORS,
        variables() {
          return this.contractorAutocompleteFilter;
        },
        update(data) {
          return data.contractor;
        },
        skip() {
          return this.withEmailSearch;
        },
      },
      contractorsPrivate: {
        query: GET_CONTRACTORS_WITH_PRIVATE_DATA,
        variables() {
          return this.contractorAutocompleteFilter;
        },
        update(data) {
          return data.contractor;
        },
        skip() {
          return !this.withEmailSearch;
        },
      },
    },
  })
  export default class ContractorsMultiselect extends Vue {
    @Prop({ required: true, type: Array }) value!: string[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ default: true, type: Boolean }) multiple!: boolean;
    @Prop({ default: false, type: Boolean }) invalid!: boolean;
    @Prop({ default: false, type: Boolean }) disabled!: boolean;
    @Prop({ type: String, default: undefined }) readonly placeholder?: string;
    @Prop({ type: Object, default: () => ({}) }) contractorsConditions!: Object;
    @Prop({ type: Boolean, default: false }) readonly withEmailSearch!: boolean;

    contractorsPublic: Contractor[] = [];
    contractorsPrivate: Contractor[] = [];
    contractorSearchString = "";

    get contractors(): Contractor[] {
      if (this.withEmailSearch) {
        return this.contractorsPrivate;
      }
      return this.contractorsPublic;
    }

    get isLoading(): boolean {
      const { contractorsPublic, contractorsPrivate } = this.$apollo.queries;
      if (this.withEmailSearch) {
        return contractorsPrivate.loading;
      }
      return contractorsPublic.loading;
    }

    get placeholderText(): string {
      return this.placeholder ? this.placeholder : "Select contractor";
    }

    get contractorsOptions(): DropdownOption[] {
      return getMultiselectEmployees({
        employees: this.contractors,
        search: this.contractorSearchString,
        withEmailSearch: this.withEmailSearch,
      });
    }

    get contractorAutocompleteFilter(): Query_RootContractorArgs {
      var currentUser:User = Vue.prototype.$currentUser;
      var args = {};
      if (currentUser && currentUser.role === "MANAGER") {
        let argsTemp = { managers: { manager: { user_id: { _eq: currentUser.id } }, approved: { _eq: true } } };
        args = { ...argsTemp, ...this.contractorsConditions };
      } else {
        args = this.contractorsConditions;
      }
      return { where: args };
    }

    get chosenContractors(): EmployeeDropdownOption[] {
      return this.contractors
        .filter(contractor => this.value.some(contractorId => contractor.id === contractorId))
        .map(contractor => {
          const { id, user } = contractor;
          const { given_name, family_name, avatar } = user;
          const email = user.private_data?.email;

          return {
            id,
            name: getUserFullData(given_name!, family_name!, email!),
            given_name,
            family_name,
            avatar,
          } as EmployeeDropdownOption;
        });
    }

    handleInput(contractors: DropdownOption[]): void {
      const contractorsIds = contractors.map(contractor => contractor.id);
      this.$emit("input", contractorsIds);
    }
  }
